import type { ResponseDto } from '@app/api/dtos'
import type { DependetProductDto } from '@app/api/routes/externalProductsCatalog/dtos'
import type { DependentProductsDataSource } from '@app/types/dataSource/DependentProductsDataSource'

export const getExternalDependentProductsFromResponse = (
  response?: ResponseDto<DependetProductDto>
): DependentProductsDataSource[] | undefined => {
  if (!response) return

  const rawData: DependetProductDto[] | undefined = response.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    name: dto.name,
    barcodes: dto.barcodes?.join(' ') ?? ''
  }))
}
